import type {
  CashReport,
  AmountResponse,
  Regulation,
} from "@/interfaces/cashReport";

/**
 * Generic factory for AmountResponse
 */
export const createAmountResponse = <T>(): AmountResponse<T> => ({
  data: [],
  total: 0,
});

/**
 * Factory for full CashReport state
 */
export const createCashReportState = (): CashReport => ({
  expense: createAmountResponse<Regulation>(),
  income: createAmountResponse<Regulation>(),
  member: createAmountResponse<Regulation>(),
  assurance: createAmountResponse<Regulation>(),
  orders: createAmountResponse<Regulation>(),
  encaissements: 0,
  decaissements: 0,
  cashflow: 0,
  global_total: 0,
});

/**
 * Chiffre d'affaire
 */
export const TURNOVER_TYPE = {
  INCOME: "services",
  SUBSCRIPTION: "subscriptions",
  ASSURANCE: "assurances",
  PRODUCT_SALE: "orders",
  TURNOVER: "turnover",
} as const;

export const turnoverTypeLabels = {
  [TURNOVER_TYPE.TURNOVER]: "Chiffre d'affaires total",
  [TURNOVER_TYPE.SUBSCRIPTION]: "Abonnements",
  [TURNOVER_TYPE.INCOME]: "Services complémentaires vendus",
  [TURNOVER_TYPE.ASSURANCE]: "Assurances",
  [TURNOVER_TYPE.PRODUCT_SALE]: "Ventes de produits",
};

/**
 * Encaissements
 */
export const PAYMENT_TYPE_ENCAISSEMENT = {
  INCOME: "services",
  SUBSCRIPTION: "subscriptions",
  ASSURANCE: "assurances",
  PRODUCT_SALE: "orders",
  ENCAISSEMENT: "encaissements",
} as const;
export const paymentTypeEncaissementsLabels = {
  [PAYMENT_TYPE_ENCAISSEMENT.ENCAISSEMENT]: "Tous les encaissements",
  [PAYMENT_TYPE_ENCAISSEMENT.SUBSCRIPTION]: "Abonnements",
  [PAYMENT_TYPE_ENCAISSEMENT.INCOME]: "Services complémentaires vendus",
  [PAYMENT_TYPE_ENCAISSEMENT.ASSURANCE]: "Assurances",
  [PAYMENT_TYPE_ENCAISSEMENT.PRODUCT_SALE]: "Ventes de produits",
};

/**
 * Décaissements
 */
export const PAYMENT_TYPE_DECAISSEMENT = {
  DECAISSEMENT: "décaissements",
  EXPENSE: "expenses",
} as const;
export const paymentTypeLabels = {
  [PAYMENT_TYPE_DECAISSEMENT.DECAISSEMENT]: "Tous les décaissements",
  [PAYMENT_TYPE_DECAISSEMENT.EXPENSE]: "Dépenses",
};

export const PAYMENT_TYPE_PATH = {
  INCOME: "Domain\\Income\\Income",
  SUBSCRIPTION: "Domain\\Member\\MemberSubscription",
  ASSURANCE: "Domain\\Member\\MemberAssurance",
  EXPENSE: "Domain\\Expense\\Expense",
  TRAINER: "Domain\\Trainer\\Trainer",
  PRODUCT_SALE: "Domain\\Product\\ProductSale",
} as const;

export const paymentTypePathLabels = {
  [PAYMENT_TYPE_PATH.INCOME]: "Service complémentaire",
  [PAYMENT_TYPE_PATH.SUBSCRIPTION]: "Abonnement",
  [PAYMENT_TYPE_PATH.ASSURANCE]: "Assurance",
  [PAYMENT_TYPE_PATH.EXPENSE]: "Dépense",
  [PAYMENT_TYPE_PATH.TRAINER]: "Salaire coach",
  [PAYMENT_TYPE_PATH.PRODUCT_SALE]: "Vente de produit",
};
